import { createContext } from 'react';

/**
 * @typedef {object} ReportBrandingValue
 * @property {string} logo - The report owner's logo URL, or '' when unknown.
 * @property {string} compagnyName - The report owner's display name (CommunityName), or '' when unknown.
 * @property {string} [primaryColor] - The owner's house-style primary colour, or '' when unknown.
 * @property {string} [secundairyColor] - The owner's house-style secondary colour, or '' when unknown.
 * @property {string} [tertairyColor] - The owner's house-style tertiary colour, or '' when unknown.
 */

/**
 * Carries the report owner's branding into the widget tree for environments
 * that have no logged-in tenant — chiefly the public shared viewer
 * (`LiveReportOpen2`), where `useSettings()` resolves the anonymous visitor's
 * (empty) tenant rather than the owner. `getPublicLiveReport2` returns the
 * owner's logo AND house-style colours server-side; the open page injects them
 * here.
 *
 * In the in-app editor / viewer there is no provider, so the defaults ('')
 * apply: `LogoWidget` falls back to `useSettings().logo` and `useChartColors`
 * to the logged-in tenant's colours.
 *
 * Kept beside `TemplateDataContext` (the LiveReport builder's local convention
 * for its contexts). Note: CLAUDE.md rule 8 nominally puts providers in
 * `src/StateManagment/`, but every reportBuilder2 context lives here.
 *
 * @type {React.Context<ReportBrandingValue>}
 */
export const ReportBrandingContext = createContext({
    logo: '',
    compagnyName: '',
    primaryColor: '',
    secundairyColor: '',
    tertairyColor: '',
});

export default ReportBrandingContext;
